// I know it isn't i18n :) But it gives a basis to be able to make
// it translatable in the future -- if it becomes a necessity

import get from 'lodash/get';
import nl from './i18n/nl';

const languages = {
  nl,
};

export default (key, lang = 'nl') => {
  if (typeof languages[lang] === 'undefined') {
    return key;
  }

  return get(languages[lang], key, key);
};



// WEBPACK FOOTER //
// ./src/i18n.js